import type { Coverage } from '../types';
import { PayableNow, StruckFee } from './search';

/**
 * Profile online-visit box, header price (`priceSlot`): struck fee and what the patient pays — the
 * only change in the box. `null` keeps the box's own price.
 */
export const corporateProfilePrice = (coverage: Coverage) => {
  if (coverage.status !== 'full' && coverage.status !== 'partial') return null;
  return (
    <span className="inline-flex items-center gap-2">
      <StruckFee toman={coverage.priceToman} />
      <PayableNow coverage={coverage} />
    </span>
  );
};
